import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { eventTracker } from '_helpers';
import { useTimer } from '../../../../hooks/useTimer';
import events from '../../events';
import VimeoPlayer from '../../components/VimeoPlayer';
import { Arrow, ArrowsContainer } from '../../../../styles/common-styles';

const LMDetails = ({
  lmLessonItemIndex,
  learning_module,
  nextLMHandler,
  previousLMHandler,
}) => {
  const {
    coachable_id, video_link, message, campaign_id
  } = learning_module.videos[lmLessonItemIndex];

  // calculates how much time is spent
  useTimer(({ duration }) => eventTracker(
    events.DZ_LM_PAGE_TIME_SPENT,
    {
      time_spent: duration,
      lm_id: campaign_id,
      activity_id: coachable_id
    }
  ));

  const onVideoStart = () => {
    eventTracker(
      events.DZ_LM_VIDEO_START,
      {
        activity_id: coachable_id,
        lm_id: campaign_id,
        lesson_oidx: lmLessonItemIndex,
        lesson_last: lmLessonItemIndex === learning_module.videos.length - 1
      }
    );
  };

  const onVideoEnded = () => {
    eventTracker(
      events.DZ_LM_VIDEO_END,
      {
        activity_id: coachable_id,
        lm_id: campaign_id,
        lesson_oidx: lmLessonItemIndex,
        lesson_last: lmLessonItemIndex === learning_module.videos.length - 1
      }
    );
  };

  useEffect(() => {
    eventTracker(
      events.DZ_LM_LAND,
      { activity_id: coachable_id, lm_id: campaign_id }
    );
  }, [lmLessonItemIndex]);

  return (
    <Container key={lmLessonItemIndex}>
      <DetailsVideoWrapper>
        <VimeoPlayer
          onVideoStart={onVideoStart}
          onVideoEnded={onVideoEnded}
          videoId={video_link}
        />
      </DetailsVideoWrapper>
      <CardSummaryFull dangerouslySetInnerHTML={{ __html: message }} />
      <ArrowsContainer>
        <Arrow
          disabled={lmLessonItemIndex === 0}
          background="#269EE2"
          onClick={previousLMHandler}
          aria-label="Previous Learning Module Lesson"
        >
          &#8678;
        </Arrow>
        <Arrow
          disabled={lmLessonItemIndex === learning_module.videos.length - 1}
          background="#269EE2"
          onClick={nextLMHandler}
          aria-label="Next Learning Module Lesson"
        >
          &#8680;
        </Arrow>
      </ArrowsContainer>
    </Container>
  );
};

export default LMDetails;

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const Container = styled.div`
  animation: ${OpacityAnimation} 0.3s;
`;

const DetailsVideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  animation: ${OpacityAnimation} 0.5s;
  opacity: 0;
  animation-fill-mode: forwards;
  animation-delay: 0.7s;
`;

const CardSummaryFull = styled.div`
  animation: ${OpacityAnimation} 0.5s;
  color: #404040 !important;
  padding: 10px 20px;

  p, li {
    color: #404040;
    font-size: 16px !important;
    font-family: Roboto, sans-serif !important;
  }

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
    margin: 20px 0 15px;
  }
 
  h1 { font-size: 20px !important;   }
  h2 { font-size: 18px !important;   }
  h3 { font-size: 16px !important;   }
  h4 { font-size: 14px !important;   }
  h5 { font-size: 13px !important;   }
  h6 { font-size: 13px !important;   }
`;
